import DeceaseSection from './DeceaseSection';

export default DeceaseSection;
